// 取扱店舗データ
export default {
	dhcStores: {
		title: 'DHC直営店一覧',
		url: 'https://www.dhc.co.jp/stores/',
		note: '※一部お取り扱いのない商品もございますので、詳しくは店頭のビューティー＆ヘルスアドバイザーまでお尋ねください。',
	},
	retailers: {
		title: '直営店以外の取り扱い店舗一覧',
		description: '全国のドラッグストア、総合スーパー、バラエティショップで販売しています。',
		stores: [
			{ name: 'IY', url: 'https://www.itoyokado.co.jp/' },
			{ name: 'R.O.U', url: 'https://www.rou-web.jp/' },
			{ name: 'アイスタイル', url: 'https://www.cosme.com/' },
			{ name: 'アインズ&トルぺ', url: 'https://ainz-tulpe.jp/shop' },
			{ name: 'アピタ・ピアゴ', url: 'https://www.uny.co.jp/' },
			{ name: 'アルカドラッグ', url: 'https://arka.co.jp/index.php' },
			{ name: 'イオンリテール', url: 'https://www.aeonretail.jp/' },
			{ name: 'イオン琉球', url: 'https://www.aeon-ryukyu.jp/' },
			{ name: 'ウエルシア薬局', url: 'https://www.welcia-yakkyoku.co.jp/' },
			{ name: 'ウォンツ', url: 'https://www.wants.co.jp/' },
			{ name: 'エバグリーン', url: 'https://hirooka-g.co.jp/store/' },
			{ name: 'キリン堂', url: 'https://www.kirindo-shop.com/manage/shop/shop.html' },
			{ name: 'クスリのアオキ', url: 'https://kusuri-aoki-shop-info.com/' },
			{ name: 'クスリのコダマ', url: 'https://www.matsukiyococokara-online.com/store/' },
			{ name: 'くすりの福太郎', url: 'https://www.kusurinofukutaro.co.jp/' },
			{ name: 'クスリ岩崎チェーン', url: 'https://www.iwachan.co.jp/' },
			{ name: 'ゲンキー', url: 'https://www.genky.co.jp/' },
			{ name: 'ココカラファイン', url: 'https://www.matsukiyococokara-online.com/store/' },
			{ name: 'コスモス薬品', url: 'https://www.cosmospc.co.jp/' },
			{ name: 'ゴダイ', url: 'https://www.godai.net/drugstore/' },
			{ name: 'ザグザグ', url: 'https://www.zagzag.co.jp/' },
			{ name: 'サッポロ<br>ドラッグストアー', url: 'https://satudora.jp/' },
			{ name: 'サンドラッグ', url: 'https://www.sundrug.co.jp/' },
			{ name: 'スギヤマ薬品', url: 'https://sugiyama-club.jp/' },
			{ name: 'スギ薬局', url: 'https://www.sugi-net.jp/tenpo/' },
			{ name: 'セキ薬品', url: 'https://www.sekiyakuhin.co.jp/' },
			{ name: 'ダイエー', url: 'https://www.daiei.co.jp/' },
			{ name: 'ダイコクドラッグ', url: 'https://daikokudrug.com/store/' },
			{ name: 'ダックス<br>シミズ薬品株式会社', url: 'http://www.dacs-shimizu.jp/' },
			{ name: 'ツルハドラッグ', url: 'https://www.tsuruha.co.jp/' },
			{ name: 'トモズ', url: 'https://www.mineiyakuhin.co.jp/store/' },
			{ name: 'トライアル', url: 'https://www.trial-net.co.jp' },
			{ name: 'ドラッグイレブン', url: 'https://www.drugeleven.com/' },
			{ name: 'ドラッグストア<br>チャーリー', url: 'https://www.axas.co.jp/' },
			{ name: 'ドラックストア<br>マック', url: 'https://www.daiya-grp.co.jp/store/' },
			{ name: 'ドン・キホーテ', url: 'https://www.donki.com/' },
			{ name: 'ハッピー・ドラッグ', url: 'http://happydrug.co.jp/' },
			{ name: 'ぱぱす', url: 'https://www.matsukiyo.co.jp/' },
			{ name: 'ビューティーライフ<br>ストアチャーリー', url: 'https://www.axas.co.jp/tabid/65/Default.aspx' },
			{ name: 'ふく薬品', url: 'http://www.fukuyakuhin.co.jp/' },
			{ name: '富士薬品', url: 'https://www.seims.co.jp' },
			{ name: 'マツモトキヨシ', url: 'https://www.matsukiyococokara-online.com/store/' },
			{ name: 'マルエドラッグ', url: 'https://marue-drug.co.jp/' },
			{ name: 'ミネ医薬品', url: 'https://shop.tomods.jp/' },
			{ name: 'ヤックスドラッグ', url: 'https://www.yacs.jp/home/index.html' },
			{ name: 'ユタカファーマシー', url: 'https://www.d-yutaka.co.jp/' },
			{ name: 'ゆめタウン', url: 'https://www.izumi.co.jp/' },
			{ name: 'レデイ薬局', url: 'https://www.lady-drug.co.jp/' },
			{ name: 'ロフト', url: 'https://www.loft.co.jp/' },
			{ name: '杏林堂', url: 'https://www.kyorindo.co.jp/' },
			{ name: '西友', url: 'https://www.seiyu.co.jp/' },
			{ name: '中部薬品', url: 'https://www.vdrug.co.jp/search/' },
			{ name: '東急ハンズ', url: 'https://hands.net/' },
			{ name: '平和堂', url: 'https://www.heiwado.jp/shop' },
			{ name: '薬王堂', url: 'https://www.yakuodo.co.jp/' },
			{ name: 'よどやドラッグ', url: 'https://www.yodoyadrug.co.jp/' },
			{ name: 'コクミン', url: 'https://www.kokumin.co.jp/' },
		],
	},
	onlineStores: [
		{
			name: 'LOHACO',
			logo: './assets/images/stores/logo_lohaco.webp',
			url: 'https://lohaco.yahoo.co.jp/search?p=DHC+%E3%83%AA%E3%83%83%E3%83%97%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%A0&sc_iid=storedev_lipseries_lp_shop_lohaco',
		},
		{
			name: 'Rakuten24',
			logo: './assets/images/stores/logo_rakuten24.webp',
			url: 'https://search.rakuten.co.jp/search/mall/DHC%E3%80%80%E3%83%AA%E3%83%83%E3%83%97%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%A0/?l-id=hld_r24_top_header_search_pc%3Fsc_iid%3Dstoredev_lipseries_lp_shop_rakuten24&sid=261122',
		},
		{
			name: 'ヨドバシカメラ',
			logo: './assets/images/stores/logo_yodobashi.webp',
			url: 'https://www.yodobashi.com/?word=DHC+%E3%83%AA%E3%83%83%E3%83%97%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%A0&sc_iid=storedev_lipseries_lp_shop_yodobasi',
		},
	],
};
